import React, { useState } from 'react';
import axios from '../config/axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import { useTheme } from '../context/ThemeContext';

function ClientImageDialog({ open, contractId, onClose }) {
  const { themeColors } = useTheme();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleUploadClientImage = async () => {
    if (!selectedFile) {
      setError('Por favor seleccione una imagen');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const formData = new FormData();
      formData.append('imagenClient', selectedFile);

      await axios.post(
        `/api/contracts/${contractId}/client-image/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      onClose(true);
    } catch (err) {
      console.error('Error:', err);
      setError(err.response?.data?.error || 'Error al cargar la imagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>Cliente con Imagen</DialogTitle>
      <DialogContent>
        {error && (
          <Typography color="error" gutterBottom align="center">
            {error}
          </Typography>
        )}

        {loading ? (
          <Box textAlign="center" my={4}>
            <CircularProgress />
          </Box>
        ) : (
          <Box textAlign="center" my={4}>
            <Typography gutterBottom>
              Seleccione la imagen enviada por el cliente
            </Typography>
            <input
              accept="image/*"
              type="file"
              onChange={(e) => setSelectedFile(e.target.files?.[0])}
              style={{ display: 'none' }}
              id="client-image-input"
            />
            <label htmlFor="client-image-input">
              <Button variant="outlined" component="span" sx={{ mb: 2 }}>
                Seleccionar Imagen
              </Button>
            </label>
            {selectedFile && (
              <>
                <Typography variant="body2" sx={{ my: 1 }}>
                  {selectedFile.name}
                </Typography>
                <Button
                  variant="contained"
                  onClick={handleUploadClientImage}
                  sx={{ 
                    backgroundColor: themeColors.primary,
                    '&:hover': { backgroundColor: themeColors.secondary }
                  }}
                >
                  Cargar Imagen
                </Button>
              </>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} color="inherit">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ClientImageDialog; 